import { render, staticRenderFns } from "./Anything.vue?vue&type=template&id=2f0618b8&scoped=true&"
import script from "./Anything.vue?vue&type=script&lang=js&"
export * from "./Anything.vue?vue&type=script&lang=js&"
import style0 from "./Anything.vue?vue&type=style&index=0&id=2f0618b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0618b8",
  null
  
)

export default component.exports